export var DEPLOY_DATE = new Date('2026-08-27T22:25:28+0000');
